import * as Types from './Types'

export function showAlert(
  header,
  text,
  type,
  firstButton = { title: '', onPress: () => {} },
  secondButton = { title: '', onPress: () => {} },
  thirdButton = { title: '', onPress: () => {} }
) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_ALERT,
      payload: {
        header,
        text,
        type,
        firstButton,
        secondButton,
        thirdButton
      }
    })
  }
}

export function hideAlert() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_ALERT
    })
  }
}

export function showSnackbar(message) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_SNACKBAR,
      payload: message
    })
  }
}

export function hideSnackbar() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_SNACKBAR
    })
  }
}

export function showCreateCorporationModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_CREATE_CORPARATION_MODAL
    })
  }
}

export function hideCreateCorporationModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_CREATE_CORPARATION_MODAL
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Config.js